<template>
  <div id="coupons-list-component">
    <div class="cards row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="card-table">
          <table class="table table-vcenter table-hover">
            <thead>
            <tr>
              <th class="th-shop">Магазин</th>
              <th>Тема промокода</th>
              <th>Промокод</th>
              <th class="th-source">Источник</th>
              <th>Дата сгорания</th>
              <th class="w-1"></th>
            </tr>
            </thead>
            <tbody>
              <tr class="table-light" v-for="item in items" :key="row.getCouponId(item)">
                <td class="align-items-center">
                  <img class="img-round" width="24" :src="row.getShopImage(item, 24)">
                  <span>{{ row.getShopName(item) }}</span>
                </td>
                <td>
                  <span class="badge bg-orange-lt">Отменен</span>
                  <span class="ms-1 me-1">/</span>
                  <span class="avatar me-1" :style="{width:'24px', height: '24px', backgroundImage: 'url('+ row.getUserCancelAvatar(item, 24, 24) +')'}"></span>
                  <span>{{ row.getUserCancelName(item) }}</span>
                  <span class="ms-1 me-1">/</span>
                  <span>{{ row.getCouponCanceled(item) }}</span>
                  <span v-show="row.hasCouponCancelDescr(item)">
                    <span class="ms-1 me-1">/</span>
                    {{ row.getCouponCancelDescr(item) }}
                  </span>
                  <p>
                      <span>
                      <b>{{ row.getCouponName(item) }}</b>
                      <template v-if="row.getCouponDescr(item)">
                       / {{ row.getCouponDescr(item) }}
                      </template>
                    </span>
                  </p>
                </td>
                <td>
                  <span v-show="row.hasCouponPromocode(item)"><b>{{ row.getCouponPromocode(item) }}</b></span>
                </td>
                <td>
                  <img width="24" :src="row.getSourceImage(item)">
                  <span>{{ row.getSourceName(item) }}</span>
                </td>
                <td>
                  <span>{{ row.getCouponDateEnd(item) }}</span>
                </td>
                <td>
                  <div class="d-flex">
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      :data-bs-target="'#modal-coupon-publish'"
                      :data-coupon-id="row.getCouponId(item)"
                      :data-source-id="row.getSourceId(item)"
                      title="Опубликовать"
                    >
                      <IconPlus class="me-2 text-muted" />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Teleport to="body">
          <CouponPublish />
        </Teleport>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import IconPlus from '@/assets/icons/IconPlus'
import {defineComponent, ref, watch} from "vue"
import element from "@/modules/promocodes/pages/coupons/components/list_coupon_cancel/services/element"
import CouponPublish from "@/modules/promocodes/pages/coupons/components/modal/CouponPublish"
import Helper from "@/services/Helper"
import Api from "@/modules/promocodes/pages/coupons/services/Api"
import DTBackend from "@/services/DTBackend"
import Image from "@/services/Image"

export default defineComponent({
  name: "ListCouponCancel",
  components: {
    IconPlus,
    CouponPublish,
  },
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    },
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)
    let actions = ref([])

    let row = {
      getCouponId: (item) => {
        return element.getCouponId(item)
      },
      getUserCancelName: (item) => {
        return element.getUserCancelName(item)
      },
      getUserCancelId: (item) => {
        return element.getUserCancelId(item)
      },
      getUserCancelAvatar: (item, w, h) => {
        let avatarHost = element.getUserCancelAvatarHost(item)
        let avatarName = element.getUserCancelAvatarName(item)
        if (avatarHost && avatarName) {
            return Image.handle(avatarHost, avatarName, w, h)
        }
        return "/assets/static/user/no_image.jpg"
      },
      getShopId: (item) => {
        return element.getShopId(item)
      },

      getShopName: (item) => {
        return element.getShopName(item)
      },

      getShopImage: (item, w) => {
        let image = element.getShopImage(item)

        if (image !== null) {
          return getImage(image["host"], image["name"], w)
        } else {
          return getImage(null, null, w)
        }
      },
      getSourceId: (item) => {
        return element.getSourceId(item)
      },
      getSourceName: (item) => {
        return element.getSourceName(item)
      },
      getSourceImage: (item) => {
        let sourceId = element.getSourceId(item)
        let sourceImage = ""

        switch (sourceId) {
          case 1: sourceImage = "/assets/static/sources/admitad.svg"
          break
          case 2: sourceImage = "/assets/static/sources/advcake.svg"
          break
        }
        return sourceImage
      },
      getCouponName: (item) => {
        return element.getCouponName(item)
      },
      getCouponLogo: (item) => {
        return element.getCouponLogo(item)
      },
      hasLogo: (item) => {
        let image = element.getCouponLogo(item)
        return image !== ""
      },
      hasCouponPromocode: (item) => {
        let promoCode = element.getCouponPromocode(item)
        return promoCode !== ""
      },
      getCouponPromocode: (item) => {
        return element.getCouponPromocode(item)
      },
      getCouponDateStart: (item) => {
        let result, dt, couponDateStart = element.getCouponDateStart(item)

        dt = new DTBackend(couponDateStart)
        result = dt.get("%D.%M.%y %H:%I")

        return result
      },
      getCouponDateEnd: (item) => {
        let result, dt, couponDateEnd = element.getCouponDateEnd(item)

        dt = new DTBackend(couponDateEnd)
        result = dt.get("%D.%M.%y %H:%I")

        return result
      },
      getCouponIsCancel: (item) => {
        return element.getCouponIsCancel(item)
      },
      getCouponCanceled: (item) => {
        let result, dt, couponCanceled = element.getCouponCanceled(item)

        dt = new DTBackend(couponCanceled)
        result = dt.get("%D.%M.%y %H:%I")

        return result
      },
      getCouponCancelDescr: (item) => {
        return element.getCouponCancelDescr(item)
      },
      hasCouponCancelDescr: (item) => {
        let cancelDescr = element.getCouponCancelDescr(item)
        return cancelDescr !== ""
      },
      getCouponIsPublish: (item) => {
        return element.getCouponIsPublish(item)
      },
      getCouponDescr: (item) => {
        return element.getCouponDescr(item)
      },
      getCouponDelst: (item) => {
        return element.getCouponDelst(item)
      },
      getPosts: (item) => {
        let posts = element.getPosts(item)
        let mapPosts = []

        for (let prop in posts) {
          let obj = posts[prop]

          mapPosts.push({
            postId: obj["post_id"],
            postTypeId: obj["post_type_id"],
            channelId: obj["channel_id"],
          })
        }

        return mapPosts
      },
    }

    let rowPost = {
      getPostId: (post) => {
        return post.postId
      },
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function getImage(host, name, w = null, h = null) {
      return Image.handle(host, name, w, h)
    }

    function onMoreShow(coupon_id) {
      actions.value[coupon_id] = {
        show: true
      }
    }

    function onMoreHide(coupon_id) {
      actions.value[coupon_id] = {
        show: false
      }
    }

    function onMoreShowHide(coupon_id) {
      actions.value[coupon_id] = {
        show: !this.isMoreShow(coupon_id)
      }
    }

    function isMoreShow(coupon_id) {
      return actions.value[coupon_id]?.show === true
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset;
      }

      Api.items(query).then((resp) => {
        let data = resp.data

        items.value.push(...data.data)

        if (data.data.length === 0) {
          eofItems.value = true
        }

        countItems.value = data.count
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    return {
      busy,
      items,
      row,
      rowPost,
      isNotFound,
      onMoreShow,
      onMoreHide,
      onMoreShowHide,
      isMoreShow,
    }
  }
})
</script>
